import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsFinance from '../../../components/video-production/explainer-videos/BenefitsFinance';
import ProcessSliderFinance from '../../../components/sliders/ProcessSliderFinance';
import SolveProblemsFinance from '../../../components/video-production/explainer-videos/SolveProblemsFinance';

lazyload({
  width: '100%',
});

const ExplainerVideosFinancial = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Financial Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/financial-explainer-video" />
        <meta
          name="description"
          content="Simplify complex financial concepts with our expertly crafted finance explainer video service. Let's tell your financial story visually."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/financial-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Financial Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Simplify complex financial concepts with our expertly crafted finance explainer video service. Let's tell your financial story visually."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/financial-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Financial Explainer Video | Prodigi",
  "description": "Simplify complex financial concepts with our expertly crafted finance explainer video service. Let's tell your financial story visually.",
  "url": "https://weprodigi.com/video-production/financial-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Financial Explainer Video Production ",
        "item": "https://weprodigi.com/video-production/financial-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Financial Explainer Video Production",
    "description": "Simplify complex financial concepts with our expertly crafted finance explainer video service. Let's tell your financial story visually.",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Frank Brown"
        },
        "datePublished": "2024-01-23",
        "reviewBody": "Prodigi's financial explainer videos are superb! They offer a clear and concise breakdown of complex financial topics, making it easier for viewers to grasp important concepts."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Lucie Russo"
        },
        "datePublished": "2024-03-20",
        "reviewBody": "Their expertise in translating financial jargon into understandable language is evident in their explainer videos. I appreciate the effort they put into making complex financial concepts accessible to everyone."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah Freeman"
        },
        "datePublished": "2024-12-13",
        "reviewBody": "They manage to simplify even the most daunting financial topics without sacrificing depth or accuracy. Highly recommend giving them a watch. ."
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/financial-explainer/financial-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Financial Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/financial-explainer-video',
                name: 'Financial Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A financial explainer video is vital for each modern financial organization. With its help, complex financial concepts will stop
                  being complex. Animated financial videos make this industry an easy-to-understand experience. Read more for detailed information!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Financial Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GcfJTZiAmd4?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Cards | Financial Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                What are the biggest challenges in the financial industry? Trust and safety. What can improve this? Good communication and customer
                support. A financial explainer video solves all these problems. It gives a clear image of complex financial concepts. Also, it
                simplifies the necessary information for this industry. In other words, it’s a helpful solution.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  What are the biggest challenges in the financial industry? Trust and safety. What can improve this? Good communication and customer
                  support. A financial explainer video solves all these problems. It gives a clear image of complex financial concepts. Also, it
                  simplifies the necessary information for this industry. In other words, it’s a helpful solution.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Financial Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              How do you answer all the questions of your customers? Of course, you can handle this! But how do you make sure that your answers are
              simple enough? There's always a stunning question. The key is financial video production.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Gu6GKjHJzLw?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Skye Capital | Financial Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  How do you create a sense of trust and safety in your brand? This issue can improve a marketing strategy. But here we have a
                  question about improving marketing strategy. A good explanation is the best improvement. Finance-related video content is the
                  answer! It's an easy way to communicate with your target audience. The shareable format of videos can take over the digital world in
                  a short time. This format is a helpful call to action for your audience. It's the best engagement strategy when your brand talks to
                  its customers.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    How do you create a sense of trust and safety in your brand? This issue can improve a marketing strategy. But here we have a
                    question about improving marketing strategy. A good explanation is the best improvement. Finance-related video content is the
                    answer! It's an easy way to communicate with your target audience. The shareable format of videos can take over the digital world
                    in a short time. This format is a helpful call to action for your audience. It's the best engagement strategy when your brand
                    talks to its customers.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Banking and Financial Services</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  The banking and finance industries can be complicated. The complicity is not about counting or understanding. It's also in building
                  trust. Such services are always followed by thoughts of risks. The financial explainer is your helping hand! Financial videos can
                  enhance customer engagement and build confidence in your brand. It's a reliable way to promote a brand. Explanation with
                  storytelling simplifies complex concepts. In this case, an explanation is the best trust-building solution. Also, it sets your brand
                  apart in a diverse market. Risks are reduced with a reasonable explanation!
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    The banking and finance industries can be complicated. The complicity is not about counting or understanding. It's also in
                    building trust. Such services are always followed by thoughts of risks. The financial explainer is your helping hand! Financial
                    videos can enhance customer engagement and build confidence in your brand. It's a reliable way to promote a brand. Explanation
                    with storytelling simplifies complex concepts. In this case, an explanation is the best trust-building solution. Also, it sets
                    your brand apart in a diverse market. Risks are reduced with a reasonable explanation!
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/m_ZtEcWzuhk?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Mortgage Wellness | Financial Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/s2ujd3vp6FE?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Velocity3X | Financial Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16 hidden md:block'}>
                  Education is a vital part of a period of rapid development where we live. Education is a broad concept. As a rule, it doesn’t have a
                  finish point. Education in finance might seem harder. But there’s a solution for everything. Enhance your learning sessions with
                  animated financial videos. They explain everything. Also, with their catchy format, explanations can be funny. Using them in public
                  education campaigns brings great attention to financial services. Now, there’s nothing complex about financial products.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Education is a vital part of a period of rapid development where we live. Education is a broad concept. As a rule, it doesn’t have
                    a finish point. Education in finance might seem harder. But there’s a solution for everything. Enhance your learning sessions with
                    animated financial videos. They explain everything. Also, with their catchy format, explanations can be funny. Using them in
                    public education campaigns brings great attention to financial services. Now, there’s nothing complex about financial products.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Financial Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Can video production for the finance industry be helpful in several ways? Do you want to learn about the main benefits of financial
              video production services? Then, scroll down!
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsFinance />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Financial Explainer Video Production Process
            </h2>
            <ProcessSliderFinance />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR FINANCIAL EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Financial Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>How to create an image for your brand? Choose the most suitable promotion for your business. </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsFinance />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Financial Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How can I measure the success of my financial explainer video?',
                    answer:
                      'To measure the success of your financial explainer video, you need to divide the number of video plays by the number of page visits or impressions.',
                  },
                  {
                    title: 'Are financial explainer videos suitable for all audiences?',
                    answer: 'The flexible format of financial explainer videos makes it easy to make them suitable for all audiences and topics.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'What makes a financial explainer video effective?',
                    answer:
                      'First of all, the professional approach. Then, well-crafted information, engaging script, impactful visuals, and audio effects.',
                  },
                  {
                    title: 'How long should a financial explainer video be?',
                    answer: 'As a rule, the best length of a financial explainer is between 90 seconds to 2 minutes.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosFinancial;
